"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppHeader = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
const StyledWrapper = styled_components_1.default.div `
  display: flex;
  z-index: 1;

  ${({ theme }) => (0, styled_components_1.css) `
    width: calc(100% + utils.rem(theme.Components.ToolBar.padding) * 2);
    margin-left: -${ui_common_components_1.utils.rem(theme.Components.ToolBar.padding)};
    margin-right: -${ui_common_components_1.utils.rem(theme.Components.ToolBar.padding)};
    padding: 0 ${ui_common_components_1.utils.rem(theme.Components.ToolBar.padding)};
  `}
`;
const StyledIconTitle = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
`;
function AppHeader({ title, onBackButtonClick }) {
    const theme = (0, styled_components_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(StyledWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.HeadingSection, { icon: {
                angle: theme.Components.AiLogo.Header.Angle,
                name: theme.Components.AiLogo.Header.Icon,
                position: 'left',
                color: theme.Color.Neutrals.Dark,
            }, onClick: onBackButtonClick, children: (0, jsx_runtime_1.jsxs)(StyledIconTitle, { children: [theme.Components.AiImage.Header.Icon.Name && ((0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: theme.Components.AiImage.Header.Icon.Name, color: theme.Components.AiImage.Header.Icon.Color, size: theme.Components.AiImage.Header.Icon.Size })), (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'Body', children: title })] }) }) }));
}
exports.AppHeader = AppHeader;
//# sourceMappingURL=AppHeader.js.map